<template>
  <div>
    <div> 
      <span
        v-if="status"
        class="size-status"
        style="color:green"
      >
        <v-icon
          small
          color="green"
          class="pb-1 icon-status"
        >
          mdi-thumb-up
        </v-icon>Liberada	
      </span>
      <span
        v-else
        class="size-status"
        style="color:red"
      >
        <v-icon
          small
          color="red"
          class="pb-1 icon-status"
        >
          mdi-thumb-down
        </v-icon>Bloqueada
      </span>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    status: {
      type: [Boolean, Number],
      required: true
    }
  }
};
</script>
  
<style>
.size-status {
  font-size: 0.95rem !important;
  font-weight: normal !important;
}

.size-status .v-icon {
  font-size: 0.9rem !important;
}

.icon-status{
  margin-right: 1.7px !important;
}
</style>